import { render } from "./GroupOrganization.vue?vue&type=template&id=23fa5b29&ts=true"
import script from "./GroupOrganization.vue?vue&type=script&lang=ts"
export * from "./GroupOrganization.vue?vue&type=script&lang=ts"

import "./styles/Groups.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__